"use strict";var t=require("styled-components").css`
    width: 100%;
    height: 0;
    padding-top: 82%;
    background: ${({theme:t})=>t.colors.common.light};
    position: relative;

    @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
        padding-top: 0;
        height: calc((100vw - 467px) * 0.91);
        max-height: 100vh;
    }

    > header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 9px;
        box-sizing: border-box;
        z-index: 10;

        .primary {
            display: grid;
            grid-auto-flow: column;
            grid-column-gap: 7px;

            @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                grid-auto-flow: row;
                grid-row-gap: 12px;
            }

            .view-wrapper {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .hint {
                margin: 0 0 0 15px;
                text-transform: uppercase;
                color: ${({theme:t})=>t.colors.common.light};
                padding: 7px 14px 7px 7px;
                transition: all 0.4s ease-in-out;
                text-align: center;
                width: max-content;
                position: relative;

                &.hidden {
                    opacity: 0;
                }

                &::after {
                    display: block;
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: ${({theme:t})=>t.colors.common.dark};
                    opacity: 0.8;
                    border-radius: 0 15px 15px 0;
                    z-index: -1;
                }

                &::before {
                    display: block;
                    content: '';
                    position: absolute;
                    height: 0;
                    width: 0;
                    right: 100%;
                    top: 50%;
                    transform: translateY(-50%);
                    opacity: 0.8;
                    border-top: 13px solid transparent;
                    border-bottom: 12px solid transparent;
                    border-right: 10px solid
                        ${({theme:t})=>t.colors.common.dark};
                }
            }

            .dropdown {
                &.view {
                    > button {
                        .label,
                        .value {
                            display: none;
                        }
                    }

                    @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                        > button {
                            display: none;
                        }

                        > ul {
                            position: relative;
                            top: 0;
                            display: grid;
                            grid-auto-flow: column;
                            padding: 0;
                            margin: 0;
                            background: transparent;

                            li {
                                color: ${({theme:t})=>t.colors.common.dark};
                                transition: all 0.2s ease-in-out;
                                background: #fff;

                                &.active {
                                    background: ${({theme:t})=>t.colors.primary.light};
                                }

                                &:first-child {
                                    border-top-left-radius: 2px;
                                    border-bottom-left-radius: 2px;
                                }

                                &:last-child {
                                    border-top-right-radius: 2px;
                                    border-bottom-right-radius: 2px;
                                }
                            }

                            button {
                                padding: 12px 10px;
                                position: relative;
                                z-index: 2;
                                grid-column-gap: 0;

                                &:hover,
                                &:focus {
                                    p {
                                        opacity: 1;
                                        transform: none;
                                    }

                                    &::after {
                                        opacity: 1;
                                        transform: translateX(-50%);
                                    }
                                }

                                svg {
                                    margin-right: 0;
                                    vertical-align: middle;
                                }

                                p {
                                    background: ${({theme:t})=>t.colors.primary.default};
                                    opacity: 0;
                                    position: absolute;
                                    top: calc(100% + 5px);
                                    left: 0;
                                    transition: all 0.2s ease-in-out;
                                    color: ${({theme:t})=>t.colors.common.light};
                                    width: max-content;
                                    padding: 7px 8px;
                                    box-shadow: ${({theme:t})=>t.shadows.high};
                                    border-radius: 1px;
                                    transform: translateY(-50%);
                                }

                                &::after {
                                    opacity: 0;
                                    transition: all 0.2s ease-in-out;
                                    display: block;
                                    content: '';
                                    position: absolute;
                                    height: 0;
                                    width: 0;
                                    left: 50%;
                                    transform: translate3D(-50%, -50%, 0);
                                    top: 100%;
                                    border-left: 5px solid transparent;
                                    border-right: 5px solid transparent;
                                    border-bottom: 5px solid
                                        ${({theme:t})=>t.colors.primary.default};
                                }
                            }
                        }
                    }
                }

                @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                    > button {
                        display: none;
                    }

                    > ul {
                        padding: 15px 23px 21px 18px;
                        display: grid;
                        grid-row-gap: 12px;
                        position: relative;
                        top: 0;
                    }
                }
            }
        }

        .secondary {
            .dropdown {
                button {
                    .label {
                        display: none;

                        @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                            display: block;
                        }
                    }
                }
            }
        }
    }

    > picture {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .aspect-ratio {
            display: none;
        }
    }

    .image-error {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 75%;
        transform: translate3d(-50%, -50%, 0);

        svg {
            width: 100%;
            height: auto;
        }

        p {
            text-align: center;
        }
    }

    &.view-5 {
        picture {
            img {
                object-fit: contain;
            }
        }
    }

    footer {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        box-sizing: border-box;
        max-width: ${({theme:t})=>t.widths.small};
        padding: 0 ${({theme:t})=>t.spacing.medium} 46px;
        z-index: 10;

        @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
            max-width: 428px;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
